import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Calendar from 'react-calendar'

// ========== PARTS ==========
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';

// ========== SCSS ==========
import '../scss/schedule.scss';

export class Schedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loading_events: false,
      selected_date: new Date(),
      is_admin: false
    }
  }

  async getMonthEvents(date = null) {
    let formatDate = (date != null) ? date.toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);

    let response = await window.doRequest('GET', {
      action: 'monthEvents',
      token: sessionStorage.getItem('token'),
      date: formatDate
    });

    if (response.status) {

      this.setState({
        loading: false,
        loading_events: false,
        eventsData: response.content.event_list,
        is_admin: response.content.is_admin
      })

    } else
        window.alert(response.message);
  }

  componentDidMount() {
    window.verifyIfIsLogged();

    this.getMonthEvents();
  }

  getDayEventsElement(date) {
    let dateKey = date.toISOString().slice(0, 10);
    if (dateKey in this.state.eventsData) {
      let elements = [];

      this.state.eventsData[dateKey].forEach((event, i) => {
        if (i <= 2)
          elements.push(
            <p key={event.id}>{event.title}</p>
          );
      });

      return elements;
    }
  }

  getSelectedDayEvents() {
    let elements = [];
    let dateKey = this.state.selected_date.toISOString().slice(0, 10);
    if (dateKey in this.state.eventsData) {
      this.state.eventsData[dateKey].forEach((event, i) => {

        let start = new Date(event.start);
        let end = new Date(event.end);

        let startHoursLabel = (start.getHours() < 10 ? '0' + start.getHours() : start.getHours());
        let startMinutesLabel = (start.getMinutes() < 10 ? '0' + start.getMinutes() : start.getMinutes());
        let endHoursLabel = (end.getHours() < 10 ? '0' + end.getHours() : end.getHours());
        let endMinutesLabel = (end.getMinutes() < 10 ? '0' + end.getMinutes() : end.getMinutes());

        elements.push(
          <div key={event.id} className="item">
            <div className="item-title">
              <div className="dot"></div>
              {
                this.state.is_admin
                  ? <Link
                      to={{
                        pathname: '/registry/schedule/' + this.state.selected_date.toISOString().split('T')[0],
                        event: event
                      }}
                    >
                      <h3>{ event.title }</h3>
                    </Link>
                  : <a href="#" onClick={(e) => {
                      e.preventDefault();
                    }}><h3>{ event.title }</h3></a>
              }
            </div>
            <div className="item-details">
              <p className="time">{ startHoursLabel + ':' + startMinutesLabel + ' - ' + endHoursLabel + ':' + endMinutesLabel }</p>
              <p>{ event.description }</p>
            </div>
          </div>
        );
      });
    } else {
      elements.push(
        <p key={Math.random()}>Nada registrado hoje...</p>
      );
    }

    return elements;
  }

  updateMonth(date) {
    this.setState({
      loading_events: true
    })

    this.getMonthEvents(date);
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="schedule">
          <div className="container">
            <h1 className="title">Agendas do projeto</h1>
            {
              this.state.loading
                ? <Loader />
                : <div className="calendar-container">
                    {
                      this.state.loading_events
                        ? <div className="events-loader"><Loader /></div>
                        : null
                    }
                    <Calendar
                      view="month"
                      tileContent={ ({date, view}) => this.getDayEventsElement(date)}
                      onChange={(value, event) => this.setState({ selected_date: value })}
                      onActiveStartDateChange={({ action, activeStartDate, value, view }) => this.updateMonth(activeStartDate)}
                      className={ this.state.loading_events ? 'waiting' : '' }
                    />
                    <div className={ 'details ' + (this.state.loading_events ? 'waiting' : '') }>
                      <div className="details-title">
                        <h4>
                          {this.state.selected_date.toLocaleDateString('pt-BR', { year: 'numeric', month: 'long', day: 'numeric' })}
                        </h4>
                        <small>
                          {this.state.selected_date.toLocaleDateString('pt-BR', { weekday: 'long' })}
                        </small>
                      </div>
                      <div className="event-list">
                        { this.getSelectedDayEvents() }
                      </div>
                      {
                        this.state.is_admin
                          ? <Link className="btn filled purple" to={'/registry/schedule/' + this.state.selected_date.toISOString().split('T')[0]}>Novo...</Link>
                          : null
                      }
                    </div>
                  </div>
            }
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default Schedule
